import type { IBuild } from "../../model/model";
import type { IBuildTemplateVersions, ITemplateVersion } from "./state/buildsSlice";

const AUTO_BUILDABLE_PLATFORMS = ["Windows10", "Android", "OculusQuest", "PicoNeo", "WebGLApp"];

const parseVersion = (value: string | null | undefined): number[] | null => {
  if (!value) return null;
  const match = /(\d+)(?:\.(\d+))?(?:\.(\d+))?/.exec(value);
  if (!match) return null;
  return [Number(match[1]), Number(match[2] ?? 0), Number(match[3] ?? 0)];
};

export const isTemplateVersionLower = (
  buildVersion: string | null | undefined,
  currentVersion: string | null | undefined,
): boolean => {
  const a = parseVersion(buildVersion);
  const b = parseVersion(currentVersion);
  if (!a || !b) return false;
  for (let i = 0; i < 3; i += 1) {
    if (a[i] !== b[i]) return a[i] < b[i];
  }
  return false;
};

const AVAILABLE_BUILD_STATUSES: IBuild["status"][] = ["Published", "Rebuilding"];

export const isAvailableBuild = (build: IBuild): boolean =>
  AVAILABLE_BUILD_STATUSES.includes(build.status);

export const isRebuildableBuild = (build: IBuild): boolean =>
  build.is_demo !== true &&
  (!build.scorm_version || build.scorm_version === "unknown") &&
  AUTO_BUILDABLE_PLATFORMS.includes(build.target_platform);

export const currentTemplateOfBuild = (
  build: IBuild,
  templateVersions: IBuildTemplateVersions | null,
): ITemplateVersion | null => templateVersions?.byTargetPlatform?.[build.target_platform] ?? null;

export const hasTemplateUpdate = (
  build: IBuild,
  templateVersions: IBuildTemplateVersions | null,
): boolean =>
  isRebuildableBuild(build) &&
  isTemplateVersionLower(
    build.template_version,
    currentTemplateOfBuild(build, templateVersions)?.version,
  );
